import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorLearning extends InternalStaticAnchor {
	_pattern = '/learning';
}
